import { render } from "./AudioButton.vue?vue&type=template&id=8fbe276c&scoped=true&ts=true&lang=pug"
import script from "./AudioButton.vue?vue&type=script&lang=ts"
export * from "./AudioButton.vue?vue&type=script&lang=ts"

import "./AudioButton.vue?vue&type=style&index=0&id=8fbe276c&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fbe276c"]])

export default __exports__